<template>
    <div class="agents">
        <div class="title-button">
            <h1>Admin Users</h1>
            <router-link to="/admin-user/create" class="button p-3">New Admin User</router-link>
        </div>
        <div class="box">
            <form @submit.stop.prevent="doSearch" class="box__header form--inline">
                <input v-model="quickSearch" type="search" placeholder="Quick search">
                <button class="button button--small" type="submit">Search</button>
            </form>

            <vdtnet-table
                ref="table"
                :fields="fields"
                :opts="options"
                @edit="doAlertEdit"
            />

        </div>
        <!-- box -->

        </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
    name: 'AdminUserIndex',
    components: {
        VdtnetTable
    },
    data() {
        return {
            options: {
                ajax: {
                url: this.$api + 'admin-users/table',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    },
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
                pageLength: 25,
            },
            fields: {
                name: {
                    label: 'Name',
                },
                email: {
                    label: 'Email'
                },
                role: {
                    label: 'Role',
                    render: (data, type, row) => {
                        let role_label = 'Admin'
                        if (data == 2) {
                            role_label = 'Accountant'
                        }

                        return role_label
                    }
                },
                actions: {
                    searchable: false,
                    sortable: false,
                    label: ' ',
                    render: (data, type, row) => {
                        return `<a href="/admin-user/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
                    }
                }
            },
            quickSearch: '',
        }
    },
    methods: {
        doAlertEdit(data) {
            this.$router.push({ name: 'admin-edit', params: { id: data.id }})
        }
    }
}
</script>

<style lang="scss" scoped>

</style>